import { render } from "./GuestJobDetail.vue?vue&type=template&id=08879e82&scoped=true"
import script from "./GuestJobDetail.vue?vue&type=script&lang=js"
export * from "./GuestJobDetail.vue?vue&type=script&lang=js"

import "./GuestJobDetail.vue?vue&type=style&index=0&id=08879e82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08879e82"]])

export default __exports__